import { render, staticRenderFns } from "./UpgradeLink.vue?vue&type=template&id=2e98b20c&scoped=true&"
import script from "./UpgradeLink.vue?vue&type=script&lang=js&"
export * from "./UpgradeLink.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeLink.vue?vue&type=style&index=0&id=2e98b20c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98b20c",
  null
  
)

export default component.exports